import { render, staticRenderFns } from "./edit-manager.vue?vue&type=template&id=1b63a9b8&scoped=true&lang=pug&"
import script from "./edit-manager.vue?vue&type=script&lang=js&"
export * from "./edit-manager.vue?vue&type=script&lang=js&"
import style0 from "./edit-manager.vue?vue&type=style&index=0&id=1b63a9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b63a9b8",
  null
  
)

export default component.exports